import React from 'react';
import RadioButtonGroupContext from './context';

const RadioButtonGroup = ({
  children,
  defaultSelectedValue = undefined,
  name,
  onChange,
  selectedValue = undefined,
}) => {
  if (defaultSelectedValue !== undefined && selectedValue !== undefined) {
    throw new Error(`
RadioButton component can be either controlled, or uncontrolled.
If you want it to be controlled - please pass the 'selectedValue',
and update it externally via the 'onChange' callback.
If you want it to be uncontrolled - please pass the 'defaultSelectedValue',
and its updates will be handled by the Tabs component itself.
`);
  }

  return (
    <RadioButtonGroupContext.Provider
      value={{ defaultSelectedValue, name, onChange, selectedValue }}
    >
      <div role="radiogroup" className="ws-ui-radio-button-group">
        {children}
      </div>
    </RadioButtonGroupContext.Provider>
  );
};

export default RadioButtonGroup;
